// 3rd party imports
import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject } from 'mobx-react';

// bernie
import { ContextStore } from 'bernie-core';

// shared-ui
import { ILocalization, LocalizedText, withLocalization } from '@shared-ui/localization-context';

// mobx
import { Legal } from 'src/models';
import { LegalStore } from '../../stores';

// ui
import { UitkHeading, UitkSubheading, UitkText } from 'uitk-react-text';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLink } from 'uitk-react-link';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';
import { UitkSpacing } from 'uitk-react-spacing';
import { modifyLocaleParam } from '../../util/LocaleParamTransformer';

export interface TermsOfUseProps {
  context?: ContextStore;
  l10n?: ILocalization;
  legal?: LegalStore;
}

export interface TermsOfUseState {
  legal?: Legal;
}

@withLocalization
@inject('context', 'legal')
export class TermsOfUse extends React.Component<TermsOfUseProps, TermsOfUseState> {
  constructor(props) {
    super(props);

    const siteId = this.props.context.site.id;
    this.state = {
      legal: this.props.legal.getConfig(siteId),
    };
  }

  public render() {
    const { address, email, privacyPolicyLink } = this.state.legal;

    return (
      <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
        <main>
          <UitkHeading tag="h1" size={3}>
            <LocalizedText message="terms.header" />
          </UitkHeading>
          <UitkSubheading>
            <LocalizedText message="terms.modified" />
          </UitkSubheading>
          <UitkText spacing="six">
            <LocalizedText message="terms.intro" />
          </UitkText>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="terms.section1.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="terms.section1.p1" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="terms.section2.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="terms.section2.p1" />{' '}
                <UitkMoreInfoTrigger>
                  <Link to={`/${modifyLocaleParam(this.props.context.locale)}${privacyPolicyLink}`}>
                    <LocalizedText message="footer.privacyPolicy" /> <UitkIcon name="info_outline" />
                  </Link>
                </UitkMoreInfoTrigger>
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="terms.section3.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="terms.section3.p1" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="terms.section3.p2" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="terms.section3.p3" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="terms.section4.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="terms.section4.p1" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="terms.section5.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="terms.section5.p1" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="terms.section6.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="terms.section6.p1" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="terms.section7.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="terms.section7.p1" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="terms.section8.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="terms.section8.p1" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="terms.section8.p2" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="terms.section8.p3" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="terms.section8.p4" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="terms.section8.p5" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="terms.section9.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="terms.section9.p1" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="terms.section10.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="terms.section10.p1" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="terms.section11.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="terms.section11.p1" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="terms.section11.p2" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="terms.section11.p3" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="terms.section11.p4" />
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="terms.section11.p5" />
              </UitkText>
            </div>
          </UitkSpacing>

          <UitkSpacing margin={{ blockstart: 'six' }}>
            <div>
              <UitkHeading tag="h2" size={5}>
                <LocalizedText message="terms.section12.header" />
              </UitkHeading>
              <UitkText spacing="two">
                <LocalizedText message="terms.section12.p1" /> <span>{address}</span>
              </UitkText>
              <UitkText spacing="four">
                <LocalizedText message="terms.section12.p2" />{' '}
                <UitkLink inline={true}>
                  <a href={`mailto:${email}`}>{email}</a>
                </UitkLink>
              </UitkText>
            </div>
          </UitkSpacing>
        </main>
      </UitkSpacing>
    );
  }
}
